import React, { FC } from 'react';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import Popper, { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import { getChangeAutoRenewalButtonText } from '../../model/getChangeAutoRenewalButtonText';
import { ChangeAutoRenewalButtonProps } from './changeAutoRenewalButtonProps';

import styles from './ChangeAutoRenewalButton.module.scss';

const ChangeAutoRenewalButton: FC<ChangeAutoRenewalButtonProps> = ({
  isDisabled,
  isLoading,
  isNeedPayment,
  licensesSubscriptionCost,
  isLinkingInProcess,
  isHintShow,
  isPendingAcceptanceAdvanced,
  onClick,
}) => (
  <Popper
    key="button_submit_licenses"
    triggerNode={
      <div>
        <Button
          elementId="button_submit_licenses"
          type={ButtonType.PRIMARY}
          isDisabled={isDisabled}
          isLoading={isLoading}
          onClick={onClick}>
          {getChangeAutoRenewalButtonText(
            isLinkingInProcess,
            isNeedPayment,
            licensesSubscriptionCost,
            isPendingAcceptanceAdvanced
          )}
        </Button>
      </div>
    }
    placement={HintPlacement.PLACEMENT_BOTTOM}
    isShow={isHintShow && !isPendingAcceptanceAdvanced}
    popperClassName={styles.actionButtonPopper}
    containerClassName={styles.actionButtonPopperContainer}>
    {TEXTS.BILLING_LICENSES_LIST_BUTTON_TOOLTIP}
  </Popper>
);

export default React.memo(ChangeAutoRenewalButton);
